// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"1f9fda36","977":"f694aabf"}[chunkId] + ".chunk.js";
};